import produce from 'immer';

import { defaultState } from './defaultState';
import type { DataArticleDetailSuccessPayload } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  dataRequested: (state: State): State => ({ ...state, isLoading: true }),
  dataLoadSuccess: (
    state: State,
    { articles, meta, categories }: DataArticleDetailSuccessPayload
  ): State => ({
    ...state,
    categories,
    article: articles?.[0] || {},
    relatedArticles: meta?.related_articles || [],
    preloaded: true,
    isLoading: false
  }),
  dataLoadFailed: (state: State): State => ({
    ...state,
    error: true,
    isLoading: false,
    preloaded: true
  }),
  dataLoadCanceled: (state: State): State => ({
    ...state,
    isLoading: false
  })
};
